import { useState, useEffect } from 'react';
import { UserCircle } from 'lucide-react';

const SIZES = { sm: ['w-12 h-12', 'w-9 h-9'], md: ['w-14 h-14', 'w-10 h-10'] };

export const TestimonialAvatar = ({ src, name, size = 'md' }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  const [box, icon] = SIZES[size];

  if (!src || failed) {
    return (
      <div className={`${box} shrink-0 rounded-full bg-background border border-border flex items-center justify-center`} data-testid="testimonial-default-avatar">
        <UserCircle className={`${icon} text-muted-foreground`} />
      </div>
    );
  }
  return (
    <img src={src} alt={name} onError={() => setFailed(true)} className={`${box} shrink-0 rounded-full object-cover`} data-testid="testimonial-avatar-img" />
  );
};
